<template>
    <div class="user-billing">
        <div class="mobile">
            <div class="profile-title">Teach:able</div>
        </div>
        <div class="user-billing-part">
            <div class="user-billing-part-icon mobile">
                <div class="user-billing-part-icon-img">
                    <img src="../assets/img/mobile/billings-icon.png">
                </div>
                <div class="user-billing-part-icon-title">
                    Billings
                </div>
            </div>
            <div class="user-billing-part-title">
                Schools I’m Enrolled In
            </div>
            <div class="user-billing-part-description">
                Manage credit cards associated with your student enrollments on schools.
            </div>
            <div class="user-billing-part-list">
                <div class="user-billing-part-list-row">
                    <div class="user-billing-part-list-row-logo">
                        <img src="../assets/img/user-interface-logo.png">
                    </div>
                    <div class="user-billing-part-list-row-title">
                        Online Learning Hub
                    </div>
                    <div class="user-billing-part-list-row-info">
                        No card on file
                    </div>
                </div>
            </div>
        </div>
        <div class="user-billing-part">
            <div class="user-billing-part-title">
                Stored Credit Cards
            </div>
            <div class="user-billing-part-description">
                Credit cards associated with your student enrollments on schools.
            </div>
            <div class="user-billing-part-add-card">
                <el-button @click="this.$router.push('/user/addCard')">
                    Add New Card
                </el-button>
            </div>
            <div class="user-billing-card-container">
                <div class="user-billing-card" v-for="item in cards" :key="item.id">
                     <img v-if="item.bank_no[0] == 5" src="../assets/img/master-card.png" />
                     <img v-else src="../assets/img/visa-card.png" />
                     <div class="user-billing-card-details">
                        <div class="bank_no">
                            {{ formatCardNumber(item.bank_no) }}
                        </div>
                        <div class="bank_date">
                           {{ item.bank_date }}
                        </div>
                        <i @click="deleteCard(item.id)" class="el-icon-delete"></i>
                     </div>
                </div>
               
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'UserBilling',
        data() {
            return {
                cards: [],
            }
        },
        mounted() {
            this.getBankCard();
        },
        methods: {
            deleteCard(id) {
               this.$confirm('Are you sure you want to delete', 'Delete Card', {
                    type: 'warning',
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel'
                }).then(() => {
                 this.$api.request('UserBank/delete', {id}).then((result) => {
                    if (result.status == true) {
                       this.cards = result.data;
                    } else {
                        this.$message.error(result.msg);
                    }
                    this.getBankCard();
                    this.close();
                }).catch(error => {
                    this.$message.error(error.msg);
                });
                },() => {
                  this.close();
                });
            },
            formatCardNumber(num) {
                if (num.length > 0) {
                    num = num.replace(/[0-9](?=([0-9]{4}))/g, '*');
                    num = num.match(new RegExp('.{1,4}', 'g')).join(" ");
                }
                return num;
            },
            getBankCard() {
                 this.$api.request('UserBank/list', this.loginForm).then((result) => {
                    if (result.status == true) {
                       this.cards = result.data;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
        }
    }
</script>
<style lang='scss' type='text/css'>
    @import '../styles/pc/UserBilling.scss';
    @import '../styles/mobile/UserBilling.scss';
</style>
